import React from 'react';
import Select from 'react-select';
import '../App.css'; // Make sure to import your CSS file

interface CriteriaDescreteValueDropdownProps {
  options: string[],
  current_value: (number | undefined)[] | number | string[] | undefined;
  setInputValues: React.Dispatch<React.SetStateAction<number | (number | undefined)[] | string[] | undefined>>
}

const CriteriaDescreteValueDropdown: React.FC<CriteriaDescreteValueDropdownProps> = ({
  options,
  current_value = [],
  setInputValues
}) => {
  // Helper function to check if value is string array
  const isStringArray = (value: any): value is string[] => {
    return Array.isArray(value) && value.every(item => typeof item === 'string');
  };

  // Convert current_value to string[] or empty array
  const currentValues = isStringArray(current_value) ? current_value : [];

  // Format options for react-select
  const selectOptions = options.map(option => ({
    value: option,
    label: option
  }));

  // Format value for react-select
  const selectValue = currentValues.map(val => ({
    value: val,
    label: val
  }));

  const handleChange = (selectedOptions: any) => {
    if (selectedOptions && Array.isArray(selectedOptions)) {
      const values = selectedOptions.map(option => option.value);
      setInputValues(values);
    } else {
      setInputValues([]);
    }
  };

  return (
    <div className="criteria-input-container">
      <Select
        isMulti
        value={selectValue}
        onChange={handleChange}
        options={selectOptions}
        placeholder="Select categories..."
        className="criteria-react-select"
        classNamePrefix="criteria-select"
        menuPortalTarget={document.body} // This is the key addition
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }), // High z-index for menu portal
          control: (provided) => ({
            ...provided,
            minHeight: '38px',
            borderColor: '#e2e8f0',
            boxShadow: 'none',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
              borderColor: '#cbd5e1',
            }
          }),
          valueContainer: (provided) => ({
            ...provided,
            padding: '2px 8px',
            flexWrap: 'wrap',
            maxHeight: '100px',
            overflowY: 'auto',
            display: 'flex',
            alignItems: 'center'
          }),
          multiValue: (provided) => ({
            ...provided,
            backgroundColor: '#f0f5ff',
            borderRadius: '4px',
            border: '1px solid #d0e1fd',
            margin: '2px 4px 2px 0',
            display: 'flex',
            alignItems: 'center',
          }),
          multiValueLabel: (provided) => ({
            ...provided,
            fontSize: '13px',
            padding: '2px 6px',
            color: '#1A5387',
            display: 'flex',
            alignItems: 'center',
          }),
          multiValueRemove: (provided) => ({
            ...provided,
            borderLeft: '1px solid #d0e1fd',
            padding: '0 6px',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            '&:hover': {
              backgroundColor: '#d0e1fd',
              color: '#1A5387',
            }
          }),
          indicatorsContainer: (provided) => ({
            ...provided,
            height: 'auto',
            alignSelf: 'stretch',
            display: 'flex',
            alignItems: 'center',
          }),
          dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'stretch',
            color: '#718096',
            '&:hover': {
              color: '#1A5387',
            }
          }),
          clearIndicator: (provided) => ({
            ...provided,
            padding: '0 8px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            alignSelf: 'stretch',
            color: '#718096',
            '&:hover': {
              color: '#1A5387',
            }
          }),
          indicatorSeparator: (provided) => ({
            ...provided,
            margin: 0,
            alignSelf: 'stretch',
            backgroundColor: '#e2e8f0',
          }),
          placeholder: (provided) => ({
            ...provided,
            color: '#718096',
          }),
          menu: (provided) => ({
            ...provided,
            zIndex: 9999,
          }),
        }}
      />
    </div>
  );
};

export default CriteriaDescreteValueDropdown;